import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { v4 } from 'uuid';

import { generateGradientColorValues } from '../generate-gradient-value';
import getRandomColor from './get-random-color';
import ColorStop from './ColorStop/ColorStop';

import './GradientLine.scss';

const GradientLine = ({ values, handlers, additionalClass }) => {
  const [lineProps, setLineProps] = useState(null);
  const parsedLineRect = useMemo(() => (lineProps ? JSON.parse(lineProps) : null), [lineProps]);
  const gradient = `linear-gradient(to right, ${generateGradientColorValues(values)})`;

  const handleColorAdd = (event) => {
    const rect = event.target.getBoundingClientRect();
    const clickPosition = event.clientX - rect.left;
    const position = parseInt((clickPosition / rect.width) * 100, 10);
    handlers.setState(
      values
        .concat({
          color: getRandomColor(), position, opacity: 100, key: v4(),
        })
        .sort((a, b) => a.position - b.position),
    );
  };

  const colorStops = values.map((value, index) => (
    <ColorStop
      key={value.key}
      values={values}
      value={value}
      handlers={handlers}
      lineRect={parsedLineRect}
      index={index}
    />
  ));

  return (
    <div className={`gradient-line ${additionalClass}`}>
      <div className="gradient-line__line-wrapper">
        <div
          role="presentation"
          className="gradient-line__line"
          style={{ backgroundImage: gradient }}
          onClick={handleColorAdd}
          ref={(node) => node && setLineProps(JSON.stringify(node.getBoundingClientRect()))}
        />
      </div>
      {colorStops}
    </div>
  );
};

GradientLine.defaultProps = {
  additionalClass: '',
};

GradientLine.propTypes = {
  additionalClass: PropTypes.string,
  values: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string.isRequired,
      position: PropTypes.number.isRequired,
      opacity: PropTypes.number.isRequired,
    }),
  ).isRequired,
  handlers: PropTypes.shape({
    setState: PropTypes.func.isRequired,
  }).isRequired,
};

export default GradientLine;
